import { LangText } from '@/components';
import { PRIMARY_NAV_ITEMS } from '@/constants/primaryNavigation';
import { preFixImgUrl } from '@/utils';
import { useNavigate } from 'react-router-dom';
import upcomingIcon from '@/assets/svg/upcoming.svg';

const SERVICE_CARDS = [
  {
    titleKey: 'home.service.taxFreeShopping.title',
    descKey: 'home.service.taxFreeShopping.desc',
    actionKey: 'home.service.taxFreeShopping.action',
    tagKey: undefined,
    image: preFixImgUrl('38f716737c629dc1911eefad23783c8d.png'),
    path: PRIMARY_NAV_ITEMS[0].path,
  },
  {
    titleKey: 'home.service.baggageDelivery.title',
    descKey: 'home.service.baggageDelivery.desc',
    actionKey: 'home.service.baggageDelivery.action',
    tagKey: 'home.service.baggageDelivery.tag',
    image: preFixImgUrl('00cc7f23dc4c347e22d227e0e4470cd9.jpeg'),
    path: PRIMARY_NAV_ITEMS[1].path,
  },
  {
    titleKey: 'home.service.coupon.title',
    descKey: 'home.service.coupon.desc',
    actionKey: 'common.action.claimFree',
    tagKey: undefined,
    image: preFixImgUrl('df9cb693eee8799db764e510cf63121e.png'),
    path: PRIMARY_NAV_ITEMS[2].path,
  },
  {
    titleKey: 'vip.hero.title',
    descKey: 'home.service.vip.desc',
    actionKey: 'home.service.vip.action',
    tagKey: undefined,
    image: preFixImgUrl('63ea383d55de1f58288ea59d811c7b51.png'),
    path: PRIMARY_NAV_ITEMS[3].path,
  },
] as const;

const UPCOMING_ITEMS = [
  'home.service.upcoming.taxRefund',
  'home.service.upcoming.transport',
  'home.service.upcoming.ticket',
  'home.service.upcoming.hotel',
  'home.service.upcoming.onlineStore',
] as const;

const SectionTitle = () => {
  return (
    <div className="flex flex-col items-center">
      <LangText lngKey="home.service.title" className="text-[36px] font-bold leading-[50px] text-[#000]" />
      <span className="mt-[16px] h-[4px] w-[108px] rounded-full bg-primary" />
    </div>
  );
};

const ServiceCard = ({ item }: { item: typeof SERVICE_CARDS[number] }) => {
  const navigate = useNavigate();
  const openService = () => navigate(item.path);

  return (
    <div
      className="group cursor-pointer rounded-[20px] bg-white"
      role="link"
      tabIndex={0}
      onClick={openService}
      onKeyDown={(event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        openService();
      }}
    >
      <div className="h-[218px] overflow-hidden rounded-t-[20px]">
        <img
          src={item.image}
          alt=""
          className="object-cover w-full h-full transition-transform duration-500 ease-out group-hover:scale-110"
          draggable={false}
        />
      </div>
      <div className="px-[11px] pb-[12px] pt-[9px]">
        <LangText lngKey={item.titleKey} className="block text-[20px] font-bold leading-[28px] text-[#000]" />
        <div className="mt-[4px] flex items-end justify-between gap-[12px]">
          <LangText lngKey={item.descKey} className="text-[12px] leading-[18px] text-[#979797]" />
          <button
            type="button"
            className="relative h-[30px] min-w-[90px] shrink-0 rounded-full bg-primary px-[10px] text-[13px] font-medium text-white transition-opacity hover:opacity-90"
          >
            {item?.tagKey && (
              <LangText
                lngKey={item.tagKey}
                className="absolute right-[0px] top-[-10px] z-10 whitespace-nowrap rounded-[9px_9px_9px_0] bg-[#FF474A] px-[8px] text-[10px] py-[2px] text-white"
              />
            )}
            <LangText lngKey={item.actionKey} />
          </button>
        </div>
      </div>
    </div>
  );
};

const UpcomingStrip = () => {
  return (
    <div className="mt-[18px] flex h-[58px] items-center rounded-[8px] border border-dashed border-[#D8D8D8] bg-[#F2F2F2]/67 px-[12px]">
      <div className="flex w-fit shrink-0 items-center gap-[10px]">
        <img src={upcomingIcon} alt="upcoming" className="h-[28px] w-[28px]" />
        <LangText lngKey="common.status.comingSoon" className="text-[16px] font-bold text-[#000]" />
      </div>
      <div className="flex flex-1 items-center gap-[12px] justify-end">
        {UPCOMING_ITEMS.map((item) => (
          <div key={item} className="flex h-[32px] min-w-[162px] items-center justify-center rounded-full bg-white pr-[4px]">
            <div className='flex flex-1 justify-center items-center'>
              <LangText lngKey={item} className="text-[16px] font-bold text-[#000]" />
            </div>
            <LangText lngKey="common.status.comingSoon" className="rounded-full bg-[#FFF4EE] px-[8px] text-[13px] leading-[24px] text-[#FB5C00]" />
          </div>
        ))}
      </div>
    </div>
  );
};

export const ServiceEntry = () => {
  return (
    <section className="mx-auto w-[1200px] pt-[144px]">
      <SectionTitle />
      <div className="mt-[85px] grid grid-cols-4 gap-[16px]">
        {SERVICE_CARDS.map((item) => (
          <ServiceCard key={item.titleKey} item={item} />
        ))}
      </div>
      <UpcomingStrip />
    </section>
  );
};
